import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'ramda';

import { Layout } from 'layouts';
import { Huggg, StashContainer } from 'components';
import { PageTitle } from 'components/misc';
import { withHuggg, withRedirect } from 'hoc';
import { useAnalytics } from 'hooks';
import { useThemeContext } from '@huggg/react-components';
import { PoweredByHuggg as UIPoweredByHuggg } from 'components/ui';

import { getBasePathname } from 'utilities/huggg';

export const ScreensUnstashed = (props) => {
  const { huggg } = props;
  const analytics = useAnalytics();
  const backAction = useCallback(() => getBasePathname(huggg), [huggg]);
  const { shouldShowPoweredByHuggg } = useThemeContext();

  useEffect(() => {
    huggg.isSuperhuggg
      ? analytics.screenViewedSuperhugggUnstashed()
      : analytics.screenViewedHugggUnstashed();
  }, [analytics, huggg]);

  return (
    <>
      <PageTitle huggg={huggg} />

      <Layout backAction={backAction}>
        <div style={{ position: 'relative' }}>
          <div className="container" data-test-id="superhuggg-details">
            <Huggg huggg={huggg} />
            {shouldShowPoweredByHuggg && <UIPoweredByHuggg />}
          </div>

          <StashContainer huggg={huggg} />
        </div>
      </Layout>
    </>
  );
};

ScreensUnstashed.propTypes = {
  huggg: PropTypes.object.isRequired,
};

const redirectHandler = (props) => [
  props.isStashed,
  `/${props.huggg.shortcode}/stashed`,
];

export default compose(
  withHuggg,
  withRedirect(redirectHandler),
)(ScreensUnstashed);
